import React from 'react';
import { Button } from 'antd';
import { XpIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { globalConst, setConfirmationModal } from 'modules/global';

import { Visible } from 'components';

import { ActionButton } from './action-button';
import { AnswerStatus } from './answer-status';

export const Actions = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const isAnswered = useAppSelector(({ topicTest }) => topicTest.isAnswered);
  const isCorrectAnswer = useAppSelector(({ topicTest }) => topicTest.isCorrectAnswer);
  const questions = useAppSelector(({ topicTest }) => topicTest.test?.test[0]?.questions);
  const currentQuestionIndex = useAppSelector(({ topicTest }) => topicTest.currentQuestionIndex);

  const question = questions?.[currentQuestionIndex as number];

  return (
    <div className="max-md:rounded-t-4xl box-border flex w-full items-center justify-between gap-2 max-lg:bg-white max-lg:p-4 sm:gap-4">
      <div className="flex items-center gap-4">
        {currentQuestionIndex !== (questions?.length || 0) - 1 && (
          <Button
            onClick={() => dispatch(setConfirmationModal(true))}
            className="!duration-400 !rounded-lg !border-none !bg-red-50 !px-8 !py-5 !font-medium !text-red-500 !transition !ease-in-out hover:!bg-red-500 hover:!text-white max-lg:!px-3"
          >
            {t('yakunlash')}
          </Button>
        )}
        <div className="max-lg:hidden">
          <Visible if={isAnswered}>
            {isCorrectAnswer ? (
              <div className="flex items-center gap-2">
                <XpIcon />
                <span className="flex items-center text-base font-medium text-green-500">
                  +{questions?.[currentQuestionIndex]?.themed_ball || 0} XP
                </span>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <XpIcon fill={globalConst.colors.gray[400]} />
                <span className="text-base font-medium text-gray-400">{t('XP berilmadi')}</span>
              </div>
            )}
          </Visible>
        </div>
      </div>

      <div className="flex items-center justify-end gap-2 sm:gap-3">
        <AnswerStatus isVisible={isAnswered || !!question?.checked} isCorrect={isCorrectAnswer} />
        <ActionButton />
      </div>
    </div>
  );
};
